import React, { useState, useEffect } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { graphcms, QUERY_SPLIDER } from "../Graphql/Queries";
import { Link } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";

function Splider() {
  const [splideData, setSplideData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    graphcms.request(QUERY_SPLIDER).then((res) => {
      setSplideData(res.homepageSpliders);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="w-full h-[40rem] md:h-auto lg:h-auto my-10">
        <div className="h-[40rem] md:h-[35rem] w-11/12 lg:w-10/12 2xl:w-9/12 mx-auto flex flex-col md:flex-row gap-1 items-center justify-between shadow-[0_0_25px_rgba(0,0,0,0.15)] rounded-3xl bg-white p-4">
          <Skeleton className="w-full h-64 md:h-full md:w-1/2 rounded-3xl" />
          <div className="w-full md:w-1/2 p-4 flex flex-col space-y-4">
            <Skeleton className="h-8 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-[40rem] md:h-auto lg:h-auto my-10">
      <Splide
        options={{
          rewind: true,
          autoplay: true,
          pauseOnHover: false,
          perPage: 1,
        }}
        className="w-full h-full">
        {splideData?.map((splide) => {
          return (
            <SplideSlide key={splide.id} className="h-[45rem] md:h-[37rem]">
              <div className="h-[40rem] md:h-[35rem] w-11/12 lg:w-10/12 2xl:w-9/12 mx-auto flex flex-col md:flex-row gap-1 items-center justify-between shadow-[0_0_25px_rgba(0,0,0,0.15)] rounded-3xl bg-white">
                <img
                  className="w-full h-64 object-cover object-top rounded-t-3xl md:h-full md:w-1/2 md:mt-0 md:rounded-tr-none md:rounded-l-3xl"
                  src={splide.slideImage.url}
                  alt={splide.title}
                />
                <div className="w-full z-10 h-96 px-2 text-neutral-800 text-center md:static flex flex-col justify-center md:h-full md:bg-none md:text-neutral-800 lg:text-left md:px-5 lg:px-10 xl:pl-10 md:rounded-l-xl ">
                  <h3 className="mt-3 mb-4 text-lg md:text-xl xl:text-2xl font-extrabold md:mt-0 leading-6 lg:leading-loose">
                    {splide.title}
                  </h3>
                  <p className="max-h-52 overflow-hidden md:h-auto lg:overflow-visible indent-10 text-sm xl:text-base px-3 lg:px-1 mx-auto md:m-0">
                    {splide.description}
                  </p>
                  {splide.buttonRequireOrNot ? (
                    <Link to={splide.buttonLink} target="_blank">
                      <button className="mt-3 md:mt-5 py-2 px-5 bg-sky-600 transition hover:bg-sky-700 rounded-xl text-white text-base">
                        Click Here
                      </button>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </SplideSlide>
          );
        })}
      </Splide>
    </div>
  );
}

export default Splider;
